// extracted by mini-css-extract-plugin
export default {"button":"Button_button__V8Ai4","button--variant2":"Button_button--variant2__X+reo","button-last":"Button_button-last__UVA0w","button-last__icon":"Button_button-last__icon__a5p7y"};